import { render, staticRenderFns } from "./GoodsSpecForm.vue?vue&type=template&id=c258a172&scoped=true"
import script from "./GoodsSpecForm.vue?vue&type=script&lang=ts"
export * from "./GoodsSpecForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodsSpecForm.vue?vue&type=style&index=0&id=c258a172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c258a172",
  null
  
)

export default component.exports